import { useShouldShowOnboardingKanbanTour } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import type { ModalSource } from './types.tsx';

export const useCanShowNudgeTour = () => {
	const [shouldShowOnboardingKanbanTour] = useShouldShowOnboardingKanbanTour();

	return (source: ModalSource): boolean => {
		switch (source) {
			case 'board':
				return shouldShowOnboardingKanbanTour;
			case 'timeline':
				// display if eligible for either board/backlog scenarios
				return shouldShowOnboardingKanbanTour;
			case 'list':
				return true;
			default:
				return false;
		}
	};
};
